module.exports = __webpack_public_path__ + "static/media/arrow.4d709371.svg";